import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ContactUs } from '../models/contactUs.model';
import { IktvaFormService } from '../Services/app-iktvaForm.service';

@Component({
  selector: 'app-fetch-data',
  templateUrl: './fetch-data.component.html',
  styleUrls: ['./fetch-data.component.css'],
  standalone: false
})
export class FetchDataComponent implements OnInit {
  //public forecasts: WeatherForecast[];

  formContactus!: FormGroup;
  ngOnInit(): void {
    this.formContactus = this.fb.group({
      'name': ['', Validators.required],
      'companyName': ['', Validators.required],
      'companyEmail': ['', [Validators.required, Validators.email]],
      'phoneContactPerson': ['', Validators.required],
      'comments': ['', [Validators.required, Validators.maxLength(1500)]]
    });

  }

  constructor(private fb: FormBuilder, private iktvaService: IktvaFormService) {
  }

  public submitContactUs() {
    if (this.formContactus.valid) {
      let contactUs = new ContactUs();
      contactUs.Comments = this.formContactus.controls['comments'].value;
      contactUs.Email = this.formContactus.controls['companyEmail'].value;
      contactUs.CompanyName = this.formContactus.controls['companyName'].value;
      contactUs.PhoneNumber = this.formContactus.controls['phoneContactPerson'].value;
      contactUs.Name = this.formContactus.controls['name'].value;

      this.iktvaService.submitContactUs(contactUs).subscribe((data) => {
        alert('Submitted.');
        this.formContactus.controls['comments'].setValue('');
        this.formContactus.controls['companyEmail'].setValue('');
        this.formContactus.controls['companyName'].setValue('');
        this.formContactus.controls['phoneContactPerson'].setValue('');
        this.formContactus.controls['name'].setValue('');

        this.formContactus.controls['comments'].markAsUntouched();
        this.formContactus.controls['companyEmail'].markAsUntouched();
        this.formContactus.controls['companyName'].markAsUntouched();
        this.formContactus.controls['phoneContactPerson'].markAsUntouched();
        this.formContactus.controls['name'].markAsUntouched();

        this.formContactus.controls['comments'].markAsPristine();
        this.formContactus.controls['companyEmail'].markAsPristine();
        this.formContactus.controls['companyName'].markAsPristine();
        this.formContactus.controls['phoneContactPerson'].markAsPristine();
        this.formContactus.controls['name'].markAsPristine();
      })
    }
  }

}
